import * as api from '~services/api';

const formatBuildingFloorOption = bf => ({
  value: bf.floor,
  label: bf.floor,
});

export const getBuildings = async (office, text = '') => {
  const code = encodeURIComponent(`${text}`);

  let queryParameters = `?search=${code}`;
  // if (formId) queryParameters += `&forForm=${formId}`;
  if (office) queryParameters += `&officeId=${office.value}`;

  const buildingFloors = await api.get(`spaces/floors/find${queryParameters}`);

  const buildings = [];

  // Go through all floors and group them by building
  buildingFloors.forEach(floor => {
    const buildingIdx = buildings.findIndex(
      building => building.label === floor.buildingTitle
    );

    // Append if building is already added
    if (buildingIdx !== -1) {
      buildings[buildingIdx].floors.push(formatBuildingFloorOption(floor));
      // Otherwise add building
    } else {
      buildings.push({
        ...floor,
        value: floor.buildingTitle,
        label: floor.buildingTitle,
        floors: [formatBuildingFloorOption(floor)],
      });
    }
  });

  return buildings;
};

export const formatSpaceOption = (space, unknownRoom = false, suffix = '') => {
  if (!space) return null;

  if (unknownRoom) {
    return {
      value: JSON.stringify(space),
      label: 'Huonetta ei tiedossa',
    };
  }

  if (space.label) {
    return {
      value: JSON.stringify(space),
      label: `${space.label}`,
    };
  }

  let name;

  // use a common util for this maybe?
  // there's similar code in form.utils.js
  if (space.usage) {
    name = space.usage;

    // Construct space name
    if (space.nickname) {
      name = `"${space.nickname}", ${name}`;
    }
    if (space.costCentre) {
      name = `${name}, kp. ${space.costCentre}`;
    }
  } else {
    name = 'ei tilan nimeä';
  }

  return {
    value: JSON.stringify(space),
    label: `${space.floor}.${space.room}/${space.building} ${name}${suffix}`,
  };
};

export const groupSpacesByOffice = (spaces, unknownRoom) => {
  const offices = {};

  spaces.forEach(space => {
    if (offices[space.officeTitle]) {
      offices[space.officeTitle].options.push(
        formatSpaceOption(space, unknownRoom)
      );
    } else {
      offices[space.officeTitle] = {
        label: space.officeTitle,
        options: [formatSpaceOption(space, unknownRoom)],
      };
    }
  });

  return Object.values(offices);
};
